import { HdZodiacPosition } from '../../hd-gate-coordinates';

/** Formatteert enkel het graden-deel van een zodiacpositie: `dd°mm'ss"`. */
export function formatHdZodiacDegrees(position: HdZodiacPosition): string {
  const dd = String(position.degree).padStart(2, '0');
  const mm = String(position.minute).padStart(2, '0');
  const ss = String(position.second).padStart(2, '0');
  return `${dd}°${mm}'${ss}"`;
}

/**
 * Formatteert een zodiacpositie als `dd°mm'ss" Label`. Het sterrenbeeld-label
 * wordt ingebracht door de caller (vertaald via de zodiac-translation-scope).
 */
export function formatHdZodiacPosition(position: HdZodiacPosition, zodiacLabel: string): string {
  return `${formatHdZodiacDegrees(position)} ${zodiacLabel}`;
}

/** Aantal decimalen van de absolute graad: 0,0001° = 0,36", ruim fijner dan een basis (0,0052°). */
const HD_ABSOLUTE_DEGREE_DECIMALS = 4;

/** Getalnotatie voor {@link formatHdAbsoluteDegrees} in de taal van de gebruiker (hergebruiken in tabellen). */
export function hdAbsoluteDegreesFormat(lang: string): Intl.NumberFormat {
  return new Intl.NumberFormat(lang, {
    minimumFractionDigits: HD_ABSOLUTE_DEGREE_DECIMALS,
    maximumFractionDigits: HD_ABSOLUTE_DEGREE_DECIMALS,
  });
}

/**
 * Absolute ecliptische lengte als `267,0806°` (0-360°, 4 decimalen). Zelfde waarde in het
 * poortinfo-paneel en in de Graden-weergave van de ephemeris; afgerond naar [0, 360).
 */
export function formatHdAbsoluteDegrees(longitude: number, numberFormat: Intl.NumberFormat): string {
  const factor = 10 ** HD_ABSOLUTE_DEGREE_DECIMALS;
  const rounded = (Math.round(longitude * factor) / factor) % 360;
  return `${numberFormat.format(rounded)}°`;
}
